import { useEffect, useRef, useState } from 'react'
import { roundFloatTo } from '../../../utils'

const getDecimalPlaces = (value: number): number => {
  const str = value.toString()
  if (str.includes('.')) {
    return str.split('.')[1].length
  }
  return 0
}

export const AnimatedNumber = (props: { children: number; speed?: number }) => {
  const [animatedValue, setAnimatedValue] = useState(props.children)
  const rafRef = useRef<number>()

  useEffect(() => {
    const start = performance.now()
    const duration = props.speed ?? 300
    const initial = animatedValue
    const target = props.children

    if (initial === target) return

    const animate = (time: number) => {
      const progress = Math.min((time - start) / duration, 1)
      const nextValue = initial + (target - initial) * progress
      setAnimatedValue(nextValue)

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate)
      } else {
        setAnimatedValue(target)
      }
    }

    rafRef.current = requestAnimationFrame(animate)

    return () => cancelAnimationFrame(rafRef.current!)
  }, [props.children])

  return roundFloatTo(animatedValue, getDecimalPlaces(props.children))
}
